/* Brynn — the Revvly AI mark. Two-tone, theme-aware, with a twinkling spark.
   Ported from the design system (rv-app.css `.rv-brynn`). Colors map to brand
   tokens (line = navy ink in light / mint in dark; spark = mint / bright mint).
   The duration lives in a custom property so no raw time literal sits in a
   declaration. */

.Brynn {
  --brynn-line: var(--rv-accent-ink-deep);
  --brynn-spark: var(--rv-accent);
  --brynn-twinkle-duration: 2600ms;

  display: block;
}

.Wave {
  fill: none;
  stroke: var(--brynn-line);
  stroke-width: 2.05;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.Spark {
  fill: var(--brynn-spark);
  transform-box: fill-box;
  transform-origin: center;
  animation: brynn-twinkle var(--brynn-twinkle-duration) var(--rv-ease-in-out) infinite;
}

@keyframes brynn-twinkle {
  0%,
  100% {
    opacity: 50%;
    transform: scale(0.9) rotate(0deg);
  }

  50% {
    opacity: 100%;
    transform: scale(2) rotate(90deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .Spark {
    animation: none;
  }
}

/* Dark mode: the wave reads as soft white (cleaner on the dark menu/chips than
   an all-mint mark), with the spark keeping the mint brand pop. */
:global(html[data-color-mode='dark']) .Brynn {
  --brynn-line: var(--rv-fg-1);
  --brynn-spark: var(--rv-accent);
}
